import React, {useEffect} from 'react'
import { Route, Switch } from 'react-router-dom'

import ActivitiesLanding from '../ActivitiesLanding/ActivitiesLanding'

interface MainProps {
	onAuthFail?: () => void
}

export const Main: React.FC<MainProps> = (props: MainProps) => {

	return (
		<div id="app-main-content" style={{ margin: '0 auto', padding: '16px' }}>
			<Switch>
				<Route path="" component={ActivitiesLanding} />
			</Switch>
		</div>
	)
}

export default Main
